import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonService } from 'src/app/shared/common.service';
import { ToastService } from 'src/app/shared/toast.service';

@Component({
  selector: 'app-empower-future',
  templateUrl: './empower-future.component.html',
  styleUrls: ['./empower-future.component.scss']
})
export class EmpowerFutureComponent {
showVideoPopup = false;
popupVideoUrl!: SafeResourceUrl;
selectedVideo: any = null;
activeTab: string = 'overview';

liveSessionCards: any[] = [];
 allSessions: any[] = [];
  showPopup = false;
  selectedSession: any = null;

  // Registration form fields
  firstName = '';
  lastName = '';
  email = '';
isOpen: boolean[] = [false, false, false, false, false, false];


    constructor(private sanitizer: DomSanitizer, private http: HttpClient, private toast: ToastService, private commonService: CommonService) {}
  


      playVideoPopup() {
  // Sanitize video URL for iframe
  this.popupVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/Ktw2Ssdi7Co');

  // Store title and description for popup display
  this.selectedVideo = {
  title: 'Dealing with change',
  description: 'Feeling the Shift?  Here How to Deal with Change Like a Pro!',
  fileUrl: 'https://www.youtube.com/embed/Ktw2Ssdi7Co'
};

  this.activeTab = 'overview';
  this.showVideoPopup = true;
}


closeVideoPopup() {
  this.showVideoPopup = false;
  this.popupVideoUrl = undefined!;
  this.selectedVideo = null;
 }

 toggleAccordion(index: number) {
    this.isOpen[index] = !this.isOpen[index]; // Toggle the state of the clicked item
  }

 loadSessions() {
  this.commonService.getFreeEventSessions().subscribe({
    next: (res: any) => {
      if (res.status === 1) {
        this.allSessions = res.data.map((event: any) => ({
          _id: event._id,
          title: event.title,
          description: event.description,
          sessions: event.sessions || []
        }));
        console.log('allSessions', this.allSessions);
      }
    },
    error: () => this.toast.showError('Failed to load live sessions')
  });
}


 openPopup(session: any) {
  this.selectedSession = session;
  this.showPopup = true;
}

closePopup() {
  this.showPopup = false;
  this.firstName = this.lastName = this.email = '';
}

registerForSession() {
  if (!this.firstName || !this.lastName || !this.email) {
    this.toast.showError('All fields are required');
    return;
  }

  const payload = {
    eventId: this.selectedSession._id,
    sessionId: this.selectedSession?.sessions[0]?.id,
    firstName: this.firstName,
    lastName: this.lastName,
    email: this.email
  };

  this.commonService.registerForFreeSession(payload).subscribe({
    next: (res: any) => {
      if (res.status === 1 || res.message?.includes('success')) {
        this.toast.showSuccess(res.message || 'Registration successful!');

        // Redirect to Zoom link if present
        if (res.data?.zoomLink) {
          // Delay slightly to allow user to see toast (optional)
          setTimeout(() => {
            window.location.href = res.data.zoomLink;
          }, 1000); // 1 second delay
        }
      } else {
        this.toast.showError(res.message || 'Registration failed');
      }
      this.closePopup();
    },
    error: () => this.toast.showError('Something went wrong')
  });
}


scrollToLiveSession() {
  const element = document.getElementById('live-session-section');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}


openPopupFromVertual(session: any) {
  this.selectedSession = {
    _id: session.eventId,
    title: session.title,
    description: session.description || '',
    sessions: [
      {
        id: session.sessionId,  // ✅ backend expects “id” field here too
        date: session.date,
        startTime: session.startTime,
        timezone: session.timezone || 'EST'
      }
    ]
  };
  this.showPopup = true;
}

}
